module.exports = __webpack_public_path__ + "static/img/left-ruler.7f3ec24f.png";